// extracted by mini-css-extract-plugin
module.exports = {"root":"filterHeader_root__KicJ_","blocks":"filterHeader_blocks__Xrp9w flex items-center","filtersTips":"filterHeader_filtersTips__49gxZ font-oswald-bold pr-[20px] text-primary"};